<template>
    <v-card class="mt-2">
        <v-card-text>
            <v-row>
                <!-- Client Name -->
                <v-col
                    cols="12" sm="12" md="6" lg="3"
                >
                    <v-text-field
                        v-model="clientInfo.clientName.value"
                        label="Client"
                        readonly
                        density="compact"
                        variant="outlined"
                        hide-details="auto"
                        append-inner-icon="mdi-lock-outline"
                    >
                    </v-text-field>
                </v-col>

                <!-- Client Location (offers without PDF visibility row) -->
                <v-col
                    v-if="!hasPdfCheckboxRow"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="3"
                >
                    <v-text-field
                        v-model="clientInfo.clientLocation.value"
                        label="Locație"
                        readonly
                        density="compact"
                        variant="outlined"
                        hide-details="auto"
                        append-inner-icon="mdi-lock-outline"
                    >
                    </v-text-field>
                </v-col>

                <!-- Intermediary -->
                <v-col
                   cols="12" sm="12" md="12" lg="3"
                >
                    <v-text-field
                        v-model="clientInfo.intermediary.value"
                        label="Intermediar"
                        readonly
                        density="compact"
                        variant="outlined"
                        hide-details="auto"
                        append-inner-icon="mdi-lock-outline"
                    >
                    </v-text-field>
                </v-col>
               
            </v-row>
            <v-row v-if="hasPdfCheckboxRow" class="align-center">
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="3"
                >
                    <v-text-field
                        v-model="clientInfo.clientLocation.value"
                        label="Locație"
                        :readonly="!isLocationNameEditable"
                        density="compact"
                        variant="outlined"
                        hide-details="auto"
                        :class="{
                            'location-field--editable': isLocationNameEditable,
                        }"
                        :append-inner-icon="
                            isLocationNameEditable
                                ? 'mdi-pencil-outline'
                                : 'mdi-lock-outline'
                        "
                        @blur="onLocationNameBlur"
                    >
                    </v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="auto"
                    class="pdf-visibility-checkboxes"
                >
                    <OfferLocationVisibleOnPdfCheckbox
                        v-if="showLocationVisibleCheckbox"
                        :model-value="offerInfo.locationVisibleOnPdf"
                        @update:model-value="onLocationVisibleChange"
                    />
                    <OfferAreaVisibleOnPdfCheckbox
                        v-if="showAreaVisibleCheckbox"
                        :model-value="offerInfo.areaVisibleOnPdf"
                        :disabled="areaVisibleCheckboxDisabled"
                        @update:model-value="onAreaVisibleChange"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12" lg="4" v-if="hasAfterSlot">
                    <slot name="after"></slot>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    :lg="hasAfterSlot ? '8' : '12'"
                >
                    <v-textarea
                        v-model="offerInfo.notes"
                        placeholder="..."
                        label="Observații"
                        @blur="updateInfo"
                        density="compact"
                        variant="outlined"
                        hide-details="auto"
                        :rows="1"
                        auto-grow
                    >
                    </v-textarea>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import OfferLocationVisibleOnPdfCheckbox from "@/components/offer/OfferLocationVisibleOnPdfCheckbox.vue";
import OfferAreaVisibleOnPdfCheckbox from "@/components/offer/OfferAreaVisibleOnPdfCheckbox.vue";
import apiClient from "@/utils/apiClient";
import { showAlertModal } from "@/utils/utils";

export default {
    name: "OfferInformation",
    components: {
        OfferLocationVisibleOnPdfCheckbox,
        OfferAreaVisibleOnPdfCheckbox,
    },
    data() {
        return {
           
            observer: null,
            isOfferButtonsInView: false,
            collapsed: false,
            clientInfo: {
                clientName: {
                    label: "Client",
                    value: "",
                },
                clientLocation: {
                    label: "Locație",
                    value: "",
                },
                intermediary: {
                    label: "Intermediar",
                    value: 0,
                },
            },
            offerInfo: {
                notes: "",
                locationVisibleOnPdf: false,
                areaVisibleOnPdf: false,
            },
            locationInfo: "",
            statusOptions: [
                { label: "-----------", value: 0 },
                { label: "Trimisă", value: 1 },
                { label: "Anulată", value: 2 },
                { label: "Acceptată", value: 3 },
                { label: "Finalizată", value: 4 },
            ],
            invoiceRecipient: [
                { label: "-----------", value: 0 },
                { label: "Client", value: 1 },
                { label: "Intermediar", value: 2 },
            ],
            intermediaries: null,
            selectedCustomerType: 2,
            isSavingLocationDescription: false,
        };
    },
    emits: ["update", "offer-buttons-in-view"],
    props: {
        client: {
            type: Object,
            required: true,
        },
        location: {
            type: Object,
            required: true,
        },
        offerId: {
            type: String,
        },
        offer: {
            type: Object,
            default: null,
        },
        showLocationVisibleCheckbox: {
            type: Boolean,
            default: true,
        },
        showAreaVisibleCheckbox: {
            type: Boolean,
            default: false,
        },
        areaVisibleCheckboxDisabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasAfterSlot() {
            return !!this.$slots.after;
        },
        hasPdfCheckboxRow() {
            return (
                this.showLocationVisibleCheckbox || this.showAreaVisibleCheckbox
            );
        },
        isLocationNameEditable() {
            return (
                this.showLocationVisibleCheckbox &&
                Boolean(this.offerInfo.locationVisibleOnPdf)
            );
        },
    },
    methods: {
        syncClientLocationFromProp() {
            this.clientInfo.clientLocation.value =
                this.location?.description ?? "";
        },

        pdfFlagsSource(data) {
            if (!data) {
                return null;
            }
            if (Array.isArray(data.offers) && data.offers.length) {
                return data.offers[0];
            }
            return data;
        },

        setOfferData(data) {
            const flagsSource = this.pdfFlagsSource(data);
            this.offerInfo.selectedCustomerType = data.selected_customer_type;
            this.selectedCustomerType = data.selected_customer_type;
            this.offerInfo.notes = data.notes;
            this.offerInfo.locationVisibleOnPdf = Boolean(
                flagsSource?.location_visible_on_pdf ??
                    data.location_visible_on_pdf
            );
            this.offerInfo.areaVisibleOnPdf = Boolean(
                flagsSource?.area_visible_on_pdf ?? data.area_visible_on_pdf
            );

            this.updateInfo();
        },

        onLocationVisibleChange(value) {
            this.offerInfo.locationVisibleOnPdf = Boolean(value);
            this.updateInfo();
        },

        onAreaVisibleChange(value) {
            this.offerInfo.areaVisibleOnPdf = Boolean(value);
            this.updateInfo();
        },

        offerIdentityKey(data) {
            if (!data) {
                return null;
            }
            if (data.id != null && data.id !== "") {
                return String(data.id);
            }
            const subId = data.offers?.[0]?.id;
            return subId != null && subId !== "" ? String(subId) : null;
        },

        async onLocationNameBlur() {
            if (!this.isLocationNameEditable || this.isSavingLocationDescription) {
                return;
            }

            const newName = (this.clientInfo.clientLocation.value || "").trim();
            const currentName = (this.location?.description || "").trim();

            if (!newName || newName === currentName) {
                if (!newName) {
                    this.syncClientLocationFromProp();
                }
                return;
            }

            const locationId = this.location?.id;
            if (!locationId) {
                return;
            }

            this.isSavingLocationDescription = true;
            try {
                const response = await apiClient.put(
                    `/api/locations/update-description/${locationId}/`,
                    { description: newName }
                );
                const data = response.data || {};
                const finalDescription = data.description || newName;

                // Shared object with parent (offerMixin.location); keeps PDF context in sync.
                // eslint-disable-next-line vue/no-mutating-props
                this.location.description = finalDescription;
                this.clientInfo.clientLocation.value = finalDescription;
            } catch (error) {
                console.error("Failed to save location description:", error);
                this.syncClientLocationFromProp();
                showAlertModal(
                    this.$store,
                    "A apărut o eroare la actualizarea numelui locației.",
                    "danger",
                    12000,
                    error
                );
            } finally {
                this.isSavingLocationDescription = false;
            }
        },

        updateInfo() {
            this.$emit("update", this.offerInfo);
        },
        getIntermediaryName(id) {
            if (id === null) {
                return "Fără intermediar";
            }
            return this.intermediaries.find(
                (intermediary) => intermediary.id === id
            ).name;
        },
    },
    async mounted() {
        this.intermediaries = await JSON.parse(
            sessionStorage.getItem("intermediaries")
        );

        this.clientInfo.clientName.value = this.client.full_name;
        this.syncClientLocationFromProp();
        this.clientInfo.intermediary.value = this.getIntermediaryName(
            this.client.intermediate_id
        );

        if (this.offerId) {
            this.offerInfo.parent_offer = this.offerId;
            this.setOfferData(this.offer);
        }
    },
    watch: {
        offerId(newVal) {
            this.offerInfo.parent_offer = newVal;
            this.updateInfo();
        },
        offer(newVal, oldVal) {
            const newKey = this.offerIdentityKey(newVal);
            const oldKey = this.offerIdentityKey(oldVal);
            if (!newVal) {
                return;
            }
            // Parent often replaces `offer` with a shallow copy (e.g. price list sync).
            // Only re-hydrate PDF flags when loading a different offer, not on every copy.
            if (!oldVal || newKey !== oldKey) {
                this.setOfferData(newVal);
            }
        },
        "location.description"() {
            this.syncClientLocationFromProp();
        },
        areaVisibleCheckboxDisabled: {
            handler(disabled) {
                if (disabled && this.offerInfo.areaVisibleOnPdf) {
                    this.onAreaVisibleChange(false);
                }
            },
            immediate: true,
        },
    },
};
</script>

<style scoped>
.location-field--editable :deep(.v-field__outline) {
    --v-field-border-width: 2px;
}

/* Match v-row column gutter (12px + 12px) between Locație and checkboxes */
.pdf-visibility-checkboxes {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 24px;
}
</style>
